<template>
  <div :class="$utils.isMobile() ? 'cpt-background-m' : 'cpt-background'">
    <img class="back-img" src="../assets/about-bg2-m.png" v-if="$utils.isMobile()" alt="">
    <img class="back-img" src="../assets/about-bg2.png" v-else alt="">
    <div class="content">
      <div class="text-box">
        <div class="name">
          <div class="title-en tit-en" v-if="$i18n.locale == 'zh-CN'">{{ backgroundData.titleEn }}</div>
          <div class="title tit">{{ backgroundData.title }}</div>
          <div class="box-boder"></div>
          <div :class="$i18n.locale == 'en-US' ? 'text-en' : 'text'">{{ backgroundData.info }}</div>
        </div>
        <div class="bottom-box">
          <div class="bot-tit">{{ backgroundData.textTitle }}</div>
          <div :class="$i18n.locale == 'en-US' ? 'bot-txt-en' : 'bot-txt'">{{ backgroundData.textInfo }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backgroundData: this._contentData.backgroundData
    }
  },

  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-background{
  width: auto;
  position: relative;
  display: flex;
  .content{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    // padding: 30px 0;
    .text-box{
      width: 1200px;
      .name{
        display: flex;
        // justify-content: center;
        flex-direction: column;
        // align-items: center;
        width: 600px;
        .tit-en{
          color: rgba(51, 51, 51, 0.3);
          // text-align: center;
        }
        .tit{
          color: rgba(51, 51, 51, 1);
          // text-align: center;
        }
        .box-boder{
          width: 70px;
          height: 3px;
          background: #333;
          margin: 15px 0 35px;
        }
        .text{
          font-size: 22px;
          color: #666;
          // font-family: MiSans-Normal;
        }
        .text-en{
          font-size: 18px;
          color: #666;
          // font-family: MiSans-Normal;
        }
      }
      .bottom-box{
        // width: 1040px;
        padding: 40px 80px;
        background: rgba(64, 126, 160, 0.8);
        text-align: center;
        margin-top: 50px;
        .bot-tit{
          font-size: 30px;
          color: #fff;
          // font-family: MiSans-Demibold;
          margin-bottom: 10px;
        }
        .bot-txt{
          font-size: 22px;
          color: #fff;
          // font-family: MiSans-Normal;
        }
        .bot-txt-en{
          font-size: 18px;
          color: #fff;
          // font-family: MiSans-Normal;
        }
      }
    }
  }
}
.cpt-background-m{
  width: auto;
  position: relative;
  display: flex;
  .back-img{
    width: 100%;
    // height: 510px;
    overflow: hidden;
  }
  .content{
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    .text-box{
      width: 100%;
      .name{
        display: flex;
        // justify-content: center;
        flex-direction: column;
        align-items: center;
        width: auto;
        padding: 40px;
        .tit-en{
          color: rgba(51, 51, 51, 0.3);
          // text-align: center;
        }
        .tit{
          color: rgba(51, 51, 51, 1);
          // text-align: center;
        }
        .box-boder{
          width: 30px;
          height: 2px;
          background: #333;
          margin: 15px 0 35px;
        }
        .text{
          font-size: 10px;
          color: #666;
          // font-family: MiSans-Normal;
        }
        .text-en{
          font-size: 8px;
          color: #666;
          // font-family: MiSans-Normal;
        }
      }
      .bottom-box{
        width: auto;
        padding: 20px 30px;
        background: rgba(64, 126, 160, 0.8);
        text-align: center;
        .bot-tit{
          font-size: 12px;
          color: #fff;
          // font-family: MiSans-Demibold;
          margin-bottom: 10px;
        }
        .bot-txt{
          font-size: 10px;
          color: #fff;
          // font-family: MiSans-Normal;
        }
        .bot-txt-en{
          font-size: 8px;
          color: #fff;
          // font-family: MiSans-Normal;
        }
      }
    }
  }
}
</style>